import { urls } from 'constants/urls';

export const isInternal = url => (url !== null && url.startsWith(urls.root)) || url === '/';
